export const SingleDigitTimeMeridianFormat = 'h:mm A';

export const CharterDateSingleDigitTimeFormat = 'YYYY-MM-DD h:mm A';
